import { useState } from 'react';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

import useForm from '../../../../../hooks/useForm';
import { renderInput, renderButton } from '../../../../common/renderUtils';
import FormHeader from '../../../../../components/common/FormHeader';
import PasswordRequirements from '../../../../common/PasswordRequirements';
import userService from '../../../../../services/userService';
import PasswordChanged from '../PasswordChanged';
import { newPasswordSchema } from '../../../../../helpers/passwordSchema';

const NewPassword = (props) => {
  const { t } = useTranslation();
  const [submitted, setSubmitted] = useState(false);
  const [passwordFocused, setPasswordFocused] = useState(false);

  const schema = newPasswordSchema();

  const initialData = { password: '', confirmPassword: '' };

  const { data, errors, handleChange, handleSubmit, isFormValid } = useForm(initialData, schema);

  // Hide the password validation error while the field is empty (requirements are shown instead)
  const passwordErrors = { ...errors, password: data.password ? '' : errors.password };
  const passwordFocusHandlers = {
    onFocus: () => setPasswordFocused(true),
    onBlur: () => setPasswordFocused(false),
  };

  const doSubmit = async () => {
    try {
      const { userId, token } = props.match.params;

      await userService.changePassword(userId, token, data.password);
      setSubmitted(true);
    } catch (ex) {
      if (ex.response && ex.response.status === 400) {
        toast.error(t('auth.invalidResetLink'));
      }
    }
  };

  switch (submitted) {
    case true:
      return <PasswordChanged />;
    default:
      return (
        <div className="auth-page">
          <form onSubmit={(e) => handleSubmit(e, doSubmit)} className="form-reset-new">
            <FormHeader title="" />
            {renderInput(
              'password',
              t('auth.newPassword'),
              'password',
              data,
              passwordErrors,
              handleChange,
              passwordFocusHandlers,
            )}
            <PasswordRequirements password={data.password} show={passwordFocused || !!data.password} />
            {renderInput('confirmPassword', t('auth.confirmPassword'), 'password', data, errors, handleChange)}
            {renderButton(t('auth.changePassword'), isFormValid())}
          </form>
        </div>
      );
  }
};

export default NewPassword;
